import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { ApiStatusModel } from '../components/welcome/models/api-status.model';

@Injectable({
  providedIn: 'root',
})
export class ApiStatusService {
  constructor(private http: HttpClient) {}

  public getApiStatus(): Observable<ApiStatusModel[]> {
    return this.http.get<ApiStatusModel[]>(`${environment.apiUrls.apiStatus}`);
  }
}
